import type { GridSize } from '@mui/material/Grid';
import { UiSchema, WidgetProps } from '@rjsf/utils';
import { CustomObjectFieldTemplate, UIGridElement } from '../shared/custom-object-field-template';
import { DynamicFormAutocomplete } from '../shared/dynamic-form-autocomplete';

export function buildHubLayoutFormUISchema(hasDoubleSided: boolean): UiSchema {
  const uiGrid: UIGridElement[] = [
    { fields: { manufacturer: 4, sidesSelection: 4, iotHubID: 4 } },
    { title: 'Towers', subtitle: '(numbers are board IDs)', fields: { towers: 12 } },
    ...(hasDoubleSided
      ? [
          {
            title: 'Double-sided settings',
            notice: {
              isEnabledPredicate: () => true,
              notice:
                'The front of a hub is the side where the kiosk is currently positioned on the left of the tower and has the cable holes on the ends.',
              severity: 'info' as const
            },
            fields: { frontName: 6 as GridSize, backName: 6 as GridSize }
          }
        ]
      : [])
  ];

  return {
    'ui:submitButtonOptions': {
      norender: true
    },
    'ui:field': 'custom',
    'ui:grid': uiGrid,
    'ui:ObjectFieldTemplate': CustomObjectFieldTemplate,
    manufacturer: {
      'ui:widget': (props: WidgetProps) => {
        return <DynamicFormAutocomplete {...props} />;
      }
    },
    sidesSelection: {
      'ui:widget': (props: WidgetProps) => {
        return <DynamicFormAutocomplete {...props} />;
      }
    },
    towers: {
      'ui:field': 'towersEditor'
    }
  };
}
